/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PruefobjektAnzahl { 
    pruefobjekt_id: string;
    titel?: string;
    anzahl?: number;
    dimension: string;
    beschreibung?: string;
}

